import React from "react";
import { ShieldCheck, CheckCircle, Lightbulb } from "lucide-react";
import { QUALITY } from "../demoData";
import { Card, CardHead, PageTitle } from "../ui";

const Ring = ({ value }) => {
  const r = 70;
  const c = 2 * Math.PI * r;
  return (
    <div className="relative w-44 h-44">
      <svg viewBox="0 0 160 160" className="w-full h-full -rotate-90">
        <circle cx="80" cy="80" r={r} fill="none" stroke="#1e293b" strokeWidth="12" />
        <circle cx="80" cy="80" r={r} fill="none" stroke="#4ade80" strokeWidth="12" strokeLinecap="round" strokeDasharray={`${(value / 100) * c} ${c}`} />
      </svg>
      <div className="absolute inset-0 flex flex-col items-center justify-center">
        <span className="text-4xl font-extrabold text-white" data-testid="quality-score">{value}</span>
        <span className="text-xs text-emerald-400 font-semibold">Excellent</span>
      </div>
    </div>
  );
};

export default function Quality() {
  return (
    <>
      <PageTitle title="Quality Score" sub="Powered by CallIntell™ AI — every call is checked and verified." />
      <div className="grid grid-cols-1 lg:grid-cols-3 gap-4">
        <Card className="p-6 flex flex-col items-center text-center" testId="quality-ring">
          <Ring value={QUALITY.score} />
          <p className="mt-4 text-sm text-slate-400">Your traffic ranks in the <span className="text-white font-semibold">top 10%</span> of the network.</p>
        </Card>
        <Card className="lg:col-span-2" testId="quality-checks">
          <CardHead icon={ShieldCheck} title="AI Quality Checks" />
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 p-5">
            {QUALITY.checks.map((c) => (
              <div key={c} className="flex items-center justify-between rounded-xl bg-[#0b0f15] border border-slate-800 px-4 py-3">
                <span className="text-sm text-slate-200">{c}</span>
                <span className="inline-flex items-center gap-1.5 text-emerald-400 text-xs font-semibold"><CheckCircle className="w-4 h-4" />Checked</span>
              </div>
            ))}
          </div>
        </Card>
      </div>
      <Card className="mt-4" testId="quality-tips">
        <CardHead icon={Lightbulb} title="Tips to Grow Your Earnings" />
        <ul className="p-5 space-y-3">
          {QUALITY.tips.map((t) => (
            <li key={t} className="flex gap-3 text-sm text-slate-300"><Lightbulb className="w-4 h-4 text-amber-400 flex-shrink-0 mt-0.5" />{t}</li>
          ))}
        </ul>
      </Card>
    </>
  );
}
